<div class="popup-body">
  @if (!isUploaded) {
  <div class="row">
    <div class="col-12">
      <div class="form-group header">
        <h6>Nieuwe plattegronden uploaden</h6>
      </div>
    </div>
    <div class="col-12 px-0">
      <div class="form-group">
        <div class="btn btn-mdb-color btn-rounded float-left col-12">
          <div class="input-group file-upload">
            <input
              type="file"
              class="file-upload-btn form-control"
              title="kies afbeelding om te uploaden"
              (change)="onUploadSelectFile($event)"
              accept="image/png,image/jpg,image/jpeg,application/pdf,.dwg"
            />
            <input
              type="text"
              autocomplete="off"
              aria-autocomplete="none"
              class="form-control file-upload-file"
              id="in-file"
              placeholder="Zet het bestand hier neer of klik om het bestand te selecteren"
              [value]="uploadFileName"
            />
          </div>
          <small class="text-danger float-left"
            >Opmerking: de bestandsgrootte moet kleiner zijn dan 15 MB</small
          >
        </div>
      </div>
    </div>
  </div>
  }
  <br />

  @if (uploadFileName) {
  <div class="col-12">
    <div class="form-group header">
      <h6>Kaartbewerkingen</h6>
      @if (loading) {
      <bergh-loader></bergh-loader>
      }
      <bergh-preview-new-map
        [oldimgsrc]="oldimgsrc"
        [newimgsrc]="newimgsrc"
        (onSave)="saveImage($event)"
        (isMapReplaced)="isMapUploaded($event)"
        (onClose)="close()"
      ></bergh-preview-new-map>
    </div>
  </div>
  }
  <div
    class="card-footer bg-white d-flex justify-content-end"
    style="margin-top: 50px"
  >
    <button class="btn btn-secondary mr-2" (click)="close()" id="btn-cancel">
      Annuleren
    </button>
  </div>
</div>
